module.exports = __webpack_public_path__ + "static/media/atendimento-icon.08db82cb.svg";